module.exports = __webpack_public_path__ + "img/yx(10).874c847a.png";